import React from 'react';
import Table from "react-bootstrap/Table";
import { makeStyles } from '@mui/styles'
import { FaFilePdf } from 'react-icons/fa';
import HelpIcon from '@mui/icons-material/Help';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});


const BPACheckListPreview = ({ certificate,nocFromHPSEBcertificate,whetherNearbyAsiMonument_noccertificate,whetherNearbyHfl_noccertificate,nocFromNHAIcertificate,whetherSeweragePassingThrough_noccertificate,whetherSlidingArea_doc,photo,whetherAirportPermissionRequired_noc,formData }) => {

  const classes = useStyles();
  return (
    <React.Fragment>
      

      <div className="formContainer">
          <div className="formHeaderContainer">
            {/* <h2 className="formHeading">Checklist to be filled</h2> */}
          </div>
      <div className="formInputContainer">
            <Table striped bordered className="m-0" >
              <thead>
                <tr>
                  <th style={{ minWidth: 'fit-content' }}>SI#</th>
                  <th>Description</th>
                  <th style={{ minWidth: 'fit-content' }}>As per Regulations</th>
                  <th>As proposed</th>
                  <th>Remarks</th>
                  <th>Relaxation</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Type of Area</td>
                  <td>
                    <h6>Core</h6>
                    <h6>NOn Core</h6>
                    <h6>Restricted</h6>
                    <h6>Green</h6>
                    <h6>Heritage</h6>
                    <h6>Sinking</h6>
                    <h6>Sliding</h6>
                    <h6>Other</h6>
                  </td>
                  <td>
                    {formData?.typeOfArea}
                  </td>
                  <td>
                    {formData?.typeOfArea_remarks}
                  </td>
                  <td>
                     {formData?.typeOfArea_relaxation}
                  </td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Plot Area For Sub-division/Development Activity (in sq.mt.)</td>
                  <td>
                    {formData?.plotAreaForSubdivision_regulated}
                  </td>
                  <td>
                     {formData?.plotAreaForSubdivision}
                  </td>
                  <td>
                     {formData?.plotAreaForSubdivision_remarks}
                  </td>
                  <td>
                     {formData?.plotAreaForSubdivision_relaxation}
                  </td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Ownership &amp; Revenue documents</td>
                  <td>Required</td>
                  <td>{formData?.ownershipRevenueDocuments}
                  </td>
                  <td>
                    {formData?.ownershipRevenueDocuments_remarks}
                  </td>
                  <td>
                    <td>
                       {formData?.ownershipRevenueDocuments_relaxation}
                    </td>
                  </td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>Land-use *</td>
                  <td>
                    {formData?.regulatedLandUse}
                  </td>
                  <td>
                    {formData?.landUse}
                  </td>
                  <td>
                     {formData?.landUse_remarks}
                  </td>
                  <td>
                      {formData?.landUse_relaxation}
                  </td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>F.A.R.</td>
                  <td>
                     {formData?.regulatedFAR}
                  </td>
                  <td>
                     {formData?.far}
                  </td>
                  <td>
                    
                    {formData?.far_remarks}
                  </td>
                  <td>
                    {formData?.far_relaxation}
                  </td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>Built up area (in sq.mt.)</td>
                  <td>
                    
                      {formData?.regulatedBuildUpArea}
                 
                  </td>
                  <td>
                    {formData?.builtupArea}
                  </td>
                  <td>
                    {formData?.builtupArea_remarks}
                  </td>
                  <td>
                   
                    {formData?.builtupArea_relaxation}
                  </td>
                </tr>
                <tr>
                  <td rowSpan={5} style={{ verticalAlign: 'top' }}>7</td>
                  <td>
                    Setbacks(meter)
                  </td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
                <tr>
                  <td>Front</td>
                  <td>
                    {formData?.regulatedsetBacks?.front}
                  </td>
                  <td>
                    
                    {formData?.setBacks?.front}
                  </td>
                  <td rowSpan={4} style={{ verticalAlign: 'top' }}>
                    
                    {formData?.setBacks_remarks}
                  </td>
                  <td rowSpan={4} style={{ verticalAlign: 'top' }}>
                    {formData?.setBacks_relaxation}
                  </td>
                </tr>
                <tr>
                  <td>Rear</td>
                  <td>
                    
                   {formData?.regulatedsetBacks?.rear}
                  </td>
                  <td>
                    {formData?.setBacks?.rear}
                  </td>
                </tr>
                <tr>
                  <td>Left Side</td>
                  <td>
                    {formData?.regulatedsetBacks?.left}
                  </td>
                  <td>
                    {formData?.setBacks?.left}
                  </td>
                </tr>
                <tr>
                  <td>Right Side</td>
                  <td>
                     {formData?.regulatedsetBacks?.right}
                  </td>
                  <td>
                    {formData?.setBacks?.right}
                  </td>
                </tr>
                <tr>
                  <td rowSpan={5} style={{ verticalAlign: 'top' }}></td>
                  <td>
                    Whether Construction abuts with N.H Set Backs (Meter)
                  </td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
                <tr>
                  <td>Front</td>
                  <td>
                    {formData?.nhregulatedsetBacks?.front}
                  </td>
                  <td>
                     {formData?.nhsetBacks?.front}
                  </td>
                  <td rowSpan={4} style={{ verticalAlign: 'top' }}>
                    {formData?.nhsetBacks_remarks}
                  </td>
                  <td rowSpan={4} style={{ verticalAlign: 'top' }}>
                    <td rowSpan={4} style={{ verticalAlign: 'top' }}>
                      
                       {formData?.nhsetBacks_relaxation}
                    </td>
                  </td>
                </tr>
                <tr>
                  <td>Rear</td>
                  <td>
                   
                     {formData?.nhregulatedsetBacks?.rear}
                  </td>
                  <td>
                  
                    {formData?.nhsetBacks?.rear}
                  </td>
                </tr>
                <tr>
                  <td>Left Side</td>
                  <td>
                    {formData?.nhregulatedsetBacks?.left}
                  </td>
                  <td>
                    {formData?.nhsetBacks?.left}
                  </td>
                </tr>
                <tr>
                  <td>Right Side</td>
                  <td>
                    
                    {formData?.nhregulatedsetBacks?.right}
                  </td>
                  <td>
                      {formData?.nhsetBacks?.right}
                  </td>
                </tr>
                <tr>
                  <td>8</td>
                  <td>Number of storey's</td>
                  <td>Strictly Upto FAR and Upto the Height of 21 meter</td>
                  <td>
                    {formData?.numberOfStoreys}
                  </td>
                  <td>
                    {formData?.numberOfStoreys_remarks}
                  </td>
                  <td>
                     {formData?.numberOfStoreys_relaxation}
                  </td>
                </tr>
                <tr>
                  <td rowSpan={3} style={{ verticalAlign: 'top' }}>9</td>
                  <td><strong>Road/path existing at site</strong></td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td rowSpan={3} style={{ verticalAlign: 'top' }}>
                    
                     {formData?.roadPathExisting_remarks}
                  </td>
                  <td rowSpan={3}>
                    {formData?.roadPathExisting_relaxation}
                  </td>
                </tr>
                <tr>
                  <td>Existing at site</td>
                  <td>3 meter (Minimum)</td>
                  <td>
                     {formData?.existingAtSite}
                  </td>
                </tr>
                <tr>
                  <td>Shown in Tatima</td>
                  <td>Required</td>
                  <td>
                    {formData?.shownInTatima}
                  </td>
                </tr>
                <tr>
                  <td>10</td>
                  <td>Parking provision</td>
                  <td>Mandatory If Feasible</td>
                  <td>
                
                    {formData?.parkingProvision}
                  </td>
                  <td>
                    
                    {formData?.parkingProvision_remarks}
                  </td>
                  <td>
                     {formData?.parkingProvision_relaxation}
                  </td>
                </tr>
                <tr>
                  <td>11</td>
                  <td>
                    Whether any HT/LT Line, crossing over the proposed land<br />
                    
                  </td>
                  <td>{formData?.whetherHtLtLineCrossing == 'yes' && '(Upload NOC from HPSEB)'} 
                  {formData?.whetherHtLtLineCrossing === "no" &&(
                    <React.Fragment>
                    {formData?.whetherHtLtLineCrossing}</React.Fragment>
                  )}</td>
                  <td>
                    {formData?.whetherHtLtLineCrossing == 'yes' && (
                    <React.Fragment>
                    {nocFromHPSEBcertificate?.[0]?.url && (
                        <span style={{display:"flex"}}>
                        <p> <a target="_" href={nocFromHPSEBcertificate?.[0]?.url} style={{ minWidth: "80px", height: "auto", minWidth: "30px" }}>
                              <p>
                                <FaFilePdf color="#a10505" style={{ width:'20px', height:'30px'}}/>
                              </p>
                            </a></p>
                            </span>
                            )}
                            </React.Fragment>
                    )}
{formData?.whetherHtLtLineCrossing === "no" &&(
                    <React.Fragment>
                    {formData?.whetherHtLtLineCrossing}</React.Fragment>
                  )}
                  </td>
                  <td>
                    {formData?.nocFromHPSEB_remarks}
                  </td>
                  <td>
                    {formData?.nocFromHPSEB_relaxation}
                  </td>
                </tr>
                <tr>
                  <td>12</td>
                  <td>
                    Whether proposed site is located nearby ASI Protected monument<br />
                    
                  </td>
                  <td >
                  {formData?.whetherNearbyAsiMonument === "no" && (
                    <React.Fragment>
                    {formData?.whetherNearbyAsiMonument}
                    </React.Fragment>
                  )}
                    {formData?.whetherNearbyAsiMonument === 'yes' && (
                      <React.Fragment>
                        (Download NOC from the competent authority)<br />
                        Click here (https://nmanoc.nic.in/home/register)<br />
                        <strong>to apply for NOC from NMA</strong> <HelpIcon size="small" color="info" />
                      </React.Fragment>
                    )}
                  </td>
                  <td>
                     {formData?.whetherNearbyAsiMonument == 'yes' && (
                    <React.Fragment>
                    {whetherNearbyAsiMonument_noccertificate?.[0]?.url && (
                        <span style={{display:"flex"}}>
                        <p> <a target="_" href={whetherNearbyAsiMonument_noccertificate?.[0]?.url} style={{ minWidth: "80px", height: "auto", minWidth: "30px" }}>
                              <p>
                                <FaFilePdf color="#a10505" style={{ width:'20px', height:'30px'}}/>
                              </p>
                            </a></p>
                            </span>
                            )}
                            </React.Fragment>
                    )}
                    {formData?.whetherNearbyAsiMonument === "no" && (
                    <React.Fragment>
                    {formData?.whetherNearbyAsiMonument}
                    </React.Fragment>
                  )}
                  </td>
                  <td>
                     {formData?.whetherNearbyAsiMonument_remarks}
                  </td>
                  <td>
                     {formData?.whetherNearbyAsiMonument_relaxation}
                  </td>
                </tr>
                <tr>
                  <td>13</td>
                  <td>
                    Whether proposed Plan is located nearby HFL<br />
                    
                  </td>
                  <td>
                    {formData?.whetherNearbyHfl === 'yes' && '(Download NOC from the competent authority)'} 
                    {formData?.whetherNearbyHfl ==="no"&&( <React.Fragment>
                    {formData?.whetherNearbyHfl}</React.Fragment>)}</td>
                  <td>
                    {formData?.whetherNearbyHfl === 'yes' && (
                      
                      <React.Fragment>
                      {whetherNearbyHfl_noccertificate?.[0]?.url && (
                          <span style={{display:"flex"}}>
                          <p> <a target="_" href={whetherNearbyHfl_noccertificate?.[0]?.url} style={{ minWidth: "80px", height: "auto", minWidth: "30px" }}>
                                <p>
                                  <FaFilePdf color="#a10505" style={{ width:'20px', height:'30px'}}/>
                                </p>
                              </a></p>
                              </span>
                              )}
                              </React.Fragment>
                    )}
                     {formData?.whetherNearbyHfl ==="no"&&( <React.Fragment>
                    {formData?.whetherNearbyHfl}</React.Fragment>)}
                  </td>
                  <td>
                   
                    {formData?.whetherNearbyHflc_remarks}
                  </td>
                  <td>
                  
                    {formData?.whetherNearbyHflc_relaxation}
                  </td>
                </tr>
                <tr>
                  <td style={{ verticalAlign: 'top' }}>14</td>
                  <td><strong>Whether trees are standing on plot</strong><br /></td>
                  <td>{formData?.whetherTreesOnPlot}</td>
                  <td>{formData?.whetherTreesOnPlot}</td>
                  {/* <td rowSpan={formData?.whetherTreesOnPlot === 'yes' ? 5 : 2}  style={{ verticalAlign: 'top' }}>
              
                    {formData?.whetherTreesOnPlot_remarks}
                  </td> */}
                  <td></td>
                  <td > {formData?.whetherTreesOnPlot_relaxation} </td>
                </tr>
               
                <tr>
                  <td></td>
                  <td>
                    Whether plot is Abutting to Forest Boundary<br />
                    
                    Distance from Forest Boundary (Meter)
                  </td>
                  <td>
                    {/* {formData?.whetherAbuttingForestBoundary === 'yes' && (
                     <React.Fragment>
                      {formData?.distanceFromForestBoundary}
                      </React.Fragment>
                    
                    )}
                    {formData?.whetherAbuttingForestBoundary === 'no' && (
                      <React.Fragment>
                      {formData?.whetherAbuttingForestBoundary}
                      </React.Fragment>
                    )} */}
                    </td>
                  <td>
                    {/* {formData?.whetherAbuttingForestBoundary === 'yes' && (
                     <React.Fragment>
                      {formData?.distanceFromForestBoundary}
                      </React.Fragment>
                    
                    )}
                    {formData?.whetherAbuttingForestBoundary === 'no' && (
                      <React.Fragment>
                      {formData?.whetherAbuttingForestBoundary}
                      </React.Fragment>
                    )} */}
                  </td>
                  <td> </td>
                  <td></td>
                </tr>
                <tr>
                  <td>15</td>
                  <td>
                    Whether plot is Directly abutting with National Highway/State Highway/Bye-pass/Other H.P. Public Department Schedule road
                    
                  </td>
                  <td>
                    {formData?.whetherAbuttingHighway === 'yes' && (
                      <React.Fragment>
                        (Download NOC from the competent authority along with Site plan)<br />
                        Click here (https://morthnoc.nic.in) <strong>to apply for NOC from NHAI</strong> <HelpIcon size="small" color="info" />
                      </React.Fragment>
                    )}
                    {formData?.whetherAbuttingHighway === "no" && (
                      <React.Fragment>
                      {formData?.whetherAbuttingHighway}
                      </React.Fragment>
                    )}
                  </td>
                  <td>
                    {formData?.whetherAbuttingHighway === 'yes' && (
                      
                      <React.Fragment>
                      {nocFromNHAIcertificate?.[0]?.url && (
                          <span style={{display:"flex"}}>
                          <p> <a target="_" href={nocFromNHAIcertificate?.[0]?.url} style={{ minWidth: "80px", height: "auto", minWidth: "30px" }}>
                                <p>
                                  <FaFilePdf color="#a10505" style={{ width:'20px', height:'30px'}}/>
                                </p>
                              </a></p>
                              </span>
                              )}
                              </React.Fragment>
                    )}
                     {formData?.whetherAbuttingHighway === "no" && (
                      <React.Fragment>
                      {formData?.whetherAbuttingHighway}
                      </React.Fragment>
                    )}
                  </td>
                  <td>
                    
                    {formData?.whetherAbuttingHighway_remarks}
                  </td>
                  <td>
                    {formData?.whetherAbuttingHighway_relaxation}
                  </td>
                </tr>
                <tr>
                  <td  style={{ verticalAlign: 'top' }}>16</td>
                  <td>
                    Whether proposed plot is abutting to natural drainage<br />
                    
                  </td>
                  <td>{formData?.whetherAbuttingNaturalDrainage}</td>
                  <td>{formData?.whetherAbuttingNaturalDrainage}</td>
                  {/* <td rowSpan={formData?.whetherAboveRoadLevelhetherAbuttingNaturalDrainage === 'yes' ? 3 : 1} style={{ verticalAlign: 'top' }}>
                   
                    {formData?.whetherAbuttingNaturalDrainage_remarks}
                  </td> */}
                  <td></td>
                  {/* <td rowSpan={formData?.whetherAbuttingNaturalDrainage === 'yes' ? 3 : 1}>
                    
                    {formData?.whetherAbuttingNaturalDrainage_relaxation}
                  </td> */}
                  <td></td>
                </tr>
                {formData?.whetherAbuttingNaturalDrainage === 'yes' && (
                  <React.Fragment>
                    <tr>
                      <td></td>
                      <td>Distance from Nullah (Meter)</td>
                      <td>&nbsp;</td>
                      <td>
                        {formData?.distanceFromNullah}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>Distance from Khud/HFL of River (Meter)</td>
                      <td>&nbsp;</td>
                      <td>
                         {formData?.distanceFromKhudHfl}
                      </td>
                    </tr>
                  </React.Fragment>
                )}
                <tr>  
                  <td>17</td>
                  <td>
                    Whether any Pipeline/Sewerage line crossing or passing through the plot<br />
                    
                  </td>
                  <td>{formData?.whetherSeweragePassingThrough === 'yes' && '(Upload NOC from the competent authority)'} {formData?.whetherSeweragePassingThrough ==="no" &&(
                    <React.Fragment>{formData?.whetherSeweragePassingThrough}</React.Fragment>
                  )}</td>
                  <td>
                   {formData?.whetherSeweragePassingThrough === 'yes' && (
                      
                      <React.Fragment>
                      {whetherSeweragePassingThrough_noccertificate?.[0]?.url && (
                          <span style={{display:"flex"}}>
                          <p> <a target="_" href={nwhetherSeweragePassingThrough_noccertificate?.[0]?.url} style={{ minWidth: "80px", height: "auto", minWidth: "30px" }}>
                                <p>
                                  <FaFilePdf color="#a10505" style={{ width:'20px', height:'30px'}}/>
                                </p>
                              </a></p>
                              </span>
                              )}
                              </React.Fragment>
                    )}
                    {formData?.whetherSeweragePassingThrough === "no" &&(
                      <React.Fragment>
                     {formData?.whetherSeweragePassingThrough}
                      </React.Fragment>
                    )}
                  </td>
                  <td>
                     {formData?.whetherSeweragePassingThrough_remarks}
                  </td>
                  <td>
                     {formData?.whetherSeweragePassingThrough_relaxation}
                  </td>
                </tr>
                <tr>
                  <td>18</td>
                  <td>Provision of Solar Passive Building</td>
                  <td>{formData?.regulatedprovisionOfSolar}</td>
                  <td>
                    {formData?.provisionOfSolar}
                  </td>
                  <td>
                    {formData?.provisionOfSolar_remarks}
                  </td>
                  <td>
                  
                    {formData?.provisionOfSolar_relaxation}
                  </td>
                </tr>
                <tr>
                  <td>19</td>
                  <td>Provision of barrier free access for persons with disability</td>
                  <td>{formData?.regulatedprovisionForDisabiled}</td>
                  <td>
                   
                     {formData?.provisionForDisabiled}
                  </td>
                  <td>
                     {formData?.provisionForDisabiled_remarks}
                  </td>
                  <td>
                     {formData?.provisionForDisabiled_relaxation}
                  </td>
                </tr>
                <tr>
                  <td>20</td>
                  <td>
                    Whether the Proposed Plan is above the road level on Valley Side.
                    
                  </td>
                  {/* TODO: Add popup same as https://tcp.hp.gov.in/form12 */}
                  <td>{formData?.whetherAboveRoadLevel}</td>
                  <td>
                    {formData?.whetherAboveRoadLevel === 'yes' && (
                      <React.Fragment>
                      {formData?.whetherAboveRoadLevel_view}
                      </React.Fragment>
                    )}
                    {formData?.whetherAboveRoadLevel === 'no' && (
                      <React.Fragment>
                      {formData?.whetherAboveRoadLevel}
                      </React.Fragment>
                    )}
                  </td>
                  <td>
                     {formData?.whetherAboveRoadLevel_remarks}
                  </td>
                  <td>
                    {formData?.whetherAboveRoadLevel_relaxation}
                  </td>
                </tr>
                <tr>
                  <td>21</td>
                  <td>
                    Whether proposed Plan is located in Sinking and Sliding area
                    
                  </td>
                  <td> {formData?.whetherSlidingArea}</td>
                  <td>
                     {formData?.whetherSlidingArea === 'yes' && (
                      
                      <React.Fragment>
                      {whetherSlidingArea_doc?.[0]?.url && (
                          <span style={{display:"flex"}}>
                          <p> <a target="_" href={whetherSlidingArea_doc?.[0]?.url} style={{ minWidth: "80px", height: "auto", minWidth: "30px" }}>
                                <p>
                                  <FaFilePdf color="#a10505" style={{ width:'20px', height:'30px'}}/>
                                </p>
                              </a></p>
                              </span>
                              )}
                              </React.Fragment>
                    )}
                     {formData?.whetherSlidingArea === "no" && (
                        <React.Fragment>
                          {formData?.whetherSlidingArea}
                        </React.Fragment>
                     )}
                    
                  </td>
                  <td>
                    
                     {formData?.whetherSlidingArea_remarks}
                  </td>
                  <td>
                    {formData?.whetherSlidingArea_relaxation}
                    </td>
                </tr>
                <tr>
                  <td>22</td>
                  <td>Rain water harvesting tank provision</td>
                  <td>Required @20 ltr per roof top area</td>
                  <td>
                    
                  {formData?.provisionRainWaterHarvesting}
                  </td>
                  <td>
                     {formData?.provisionRainWaterHarvesting_remarks}
                  </td>
                  <td>
                    {formData?.provisionRainWaterHarvesting_relaxation}
                  </td>
                </tr>
                <tr>
                  <td>23</td>
                  <td>Structural Stability Certificate</td>
                  <td>Stability Certificate </td>
                  <td>
                  {certificate?.[0]?.url && (
                <span style={{display:"flex"}}>
                <p> <a target="_" href={certificate?.[0]?.url} style={{ minWidth: "80px", height: "auto", minWidth: "30px" }}>
                      <p>
                        <FaFilePdf color="#a10505" style={{ width:'20px', height:'30px'}}/>
                      </p>
                    </a></p>
                    </span>
                    )}
                    
                    
                  </td>
                  <td>
                    {formData?.structuralStabilityCertificate_remarks}
                  </td>
                  <td>
                     {formData?.structuralStabilityCertificate_relaxation}
                  </td>
                </tr>
                <tr>
                  <td>24</td>
                  <td>Number of Dwelling Units</td>
                  <td>8 Minimum if not for sale Otherwise 8 Maximum</td>
                  <td>
                    {formData?.numberOfDwellingUnits}
                  </td>
                  <td>
                    {formData?.numberOfDwellingUnits_remarks}
                  </td>
                  <td>
                    {formData?.numberOfDwellingUnits_relaxation}
                  </td>
                </tr>
                <tr>
                  <td rowSpan={2} style={{ verticalAlign: 'top' }}>25</td>
                  <td><strong>Risk based Classification of building</strong></td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
                <tr>
                  <td>Whether building with communication tower</td>
                  <td> {formData?.whetherCommunicationTower}</td>
                  <td>
                    {formData?.whetherCommunicationTower}
                  </td>
                  <td>
                    {formData?.whetherCommunicationTower_relaxation}
                  </td>
                  <td>
                    {formData?.whetherCommunicationTower_relaxation}
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td>Whether proposal is for Group Housing Scheme</td>
                  <td>
                    {formData?.whetherGroupHousing}
                  </td>
                  <td>
                    {formData?.whetherGroupHousing}
                  </td>
                  <td>
                    {formData?.whetherGroupHousing_remarks}
                  </td>
                  <td>
                    {formData?.whetherGroupHousing_relaxation}
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td>Whether building raised on land fill</td>
                  <td>
                    {formData?.whetherBuildingLandFill}
                  </td>
                  <td>
                    {formData?.whetherBuildingLandFill}
                  </td>
                  <td>
                    {formData?.whetherBuildingLandFill_remarks}
                  </td>
                  <td>
                    {formData?.whetherBuildingLandFill_relaxation}
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td>Whether building raised on reclaimed land</td>
                  <td>
                    {formData?.whetherRaisedReclaimed}
                  </td>
                  <td>
                    {formData?.whetherRaisedReclaimed}
                  </td>
                  <td>
                    {formData?.whetherRaisedReclaimed_remarks}
                  </td>
                  <td>
                    {formData?.whetherRaisedReclaimed_relaxation}
                  </td>
                </tr>
                <tr>
                  <td rowSpan={12} style={{ verticalAlign: 'top' }}>26</td>
                  <td><strong>General requirements</strong></td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
                <tr>
                  <td>Slope of land(Degree)</td>
                  <td>
                    {formData?.regulatedslopeOfLandDegree}
                  </td>
                  <td>
                    {formData?.slopeOfLandDegree}
                  </td>
                  <td>
                    {formData?.slopeOfLandDegree_remarks}
                  </td>
                  <td>
                    {formData?.slopeOfLandDegree_relaxation}
                  </td>
                </tr>
                <tr>
                  <td>Height of parking floor(Meter)</td>
                  <td>
                    {formData?.regulatedheightOfParkingFloor}
                  </td>
                  <td>
                    {formData?.heightOfParkingFloor}
                  </td>
                  <td>
                    {formData?.heightOfParkingFloor_remarks}
                  </td>
                  <td>
                    {formData?.heightOfParkingFloor_relaxation}
                  </td>
                </tr>
                <tr>
                  <td>Height of slopping roof(Meter)</td>
                  <td>
                    {formData?.regulatedheightOfSloppingRoof}
                  </td>
                  <td>
                    {formData?.heightOfSloppingRoof}
                  </td>
                  <td>
                    {formData?.heightOfSloppingRoof_remarks}
                  </td>
                  <td>
                    {formData?.heightOfSloppingRoof_relaxation}  
                  </td>
                </tr>
                <tr>
                  <td>Height of floor(Meter)</td>
                  <td>
                    {formData?.regulatedheightOfFloor}
                  </td>
                  <td>
                    {formData?.heightOfFloor}
                  </td>
                  <td>
                    {formData?.heightOfFloor_remarks}
                  </td>
                  <td>
                    {formData?.heightOfFloor_relaxation}
                  </td>
                </tr>
                <tr>
                  <td>Height of building(Meter)</td>
                  <td>
                    {formData?.regulatedheightOfBuilding}
                  </td>
                  <td>
                    {formData?.heightOfBuilding}
                  </td>
                  <td>
                    {formData?.heightOfBuilding_remarks}
                  </td>
                  <td>
                    {formData?.heightOfBuilding_relaxation}
                  </td>
                </tr>
                <tr>
                  <td>Maximum hill cut(Meter)</td>
                  <td>
                    {formData?.regulatedmaxHillCut}
                  </td>
                  <td>
                    {formData?.maxHillCut}
                  </td>
                  <td>
                    {formData?.maxHillCut_remarks}
                  </td>
                  <td>
                    {formData?.maxHillCut_relaxation}
                  </td>
                </tr>
                <tr>
                  <td>Distance between two blocks(Meter)</td>
                  <td>
                    {formData?.regulateddistanceBetween2Blocks}
                  </td>
                  <td>
                    {formData?.distanceBetween2Blocks}
                  </td>
                  <td>
                    {formData?.distanceBetween2Blocks_remarks}
                  </td>
                  <td>
                    {formData?.distanceBetween2Blocks_relaxation} 
                  </td>
                </tr>
                <tr>
                  <td>Plinth height(Meter)</td>
                  <td>
                    {formData?.regulatedplinthHeight}
                  </td>
                  <td>{formData?.plinthHeight}
                  </td>
                  <td>
                    {formData?.plinthHeight_remarks}
                  </td>
                  <td>
                    {formData?.plinthHeight_relaxation}
                  </td>
                </tr>
                <tr>
                  <td>Height of Service floor(Meter)</td>
                  <td>
                    {formData?.regulatedheightOfServiceFloor}
                  </td>
                  <td>
                    {formData?.heightOfServiceFloor}
                  </td>
                  <td>
                    {formData?.heightOfServiceFloor_remarks}
                  </td>
                  <td>
                    {formData?.heightOfServiceFloor_relaxation}
                  </td>
                </tr>
                <tr>
                  <td>Equivalent car Space</td>
                  <td>
                    {formData?.regulatedequivalentCarSpace}
                  </td>
                  <td>
                    {formData?.equivalentCarSpace}
                  </td>
                  <td>
                    {formData?.equivalentCarSpace_remarks}
                  </td>
                  <td> 
                    {formData?.equivalentCarSpace_relaxation}
                  </td>
                </tr>
                <tr>
                  <td>Buildable width</td>
                  <td>
                    {formData?.regulatedbuildableWidth}
                  </td>
                  <td>
                    {formData?.buildableWidth}
                  </td>
                  <td>
                    {formData?.buildableWidth_remarks}
                  </td>
                  <td>
                    {formData?.buildableWidth_relaxation}
                  </td>
                </tr>
                <tr>
                  <td>27</td>
                  <td>Photograph's of site</td>
                  <td>Photograph Doc</td>
                  <td>
                  {photo?.[0]?.url && (
                <span style={{display:"flex"}}>
                <p> <a target="_" href={photo?.[0]?.url} style={{ minWidth: "80px", height: "auto", minWidth: "30px" }}>
                      <p>
                        <FaFilePdf color="#a10505" style={{ width:'20px', height:'30px'}}/>
                      </p>
                    </a></p>
                    </span>
                    )}
                    
                    
                  </td>
                  <td>
                    {formData?.PhotographsOfSite_remarks}
                  </td>
                  <td>
                    {formData?.PhotographsOfSite_relaxation}
                  </td>
                </tr>
                <tr>
                  <td>28</td>
                  <td>Any other information</td>
                  <td> {formData?.anyOtherInformation}</td>
                  <td>
                    {formData?.anyOtherInformation}
                  </td>
                  <td>
                    {formData?.anyOtherInformation_remarks}
                  </td>
                  <td>{formData?.anyOtherInformation_relaxation}</td>
                </tr>
                <tr>
                  <td>29</td>
                  <td>
                    Whether the permission from Airport Authority of India is Required?
                    
                  </td>
                  <td>
                    {formData?.whetherAirportPermissionRequired === 'yes' && (
                      <React.Fragment>
                        (Upload NOC from the competent authority along with Site plan)<br />
                        Click here (https://nocas2.aai.aero/nocas/Registration.html)<br />
                        <strong>To apply for NOC from AAI</strong> <HelpIcon size="small" color="info" />
                      </React.Fragment>
                    )}
                  </td>
                  <td>
                     {formData?.whetherAirportPermissionRequired === 'yes' && (
                      
                      <React.Fragment>
                      {whetherAirportPermissionRequired_noc?.[0]?.url && (
                          <span style={{display:"flex"}}>
                          <p> <a target="_" href={whetherAirportPermissionRequired_noc?.[0]?.url} style={{ minWidth: "80px", height: "auto", minWidth: "30px" }}>
                                <p>
                                  <FaFilePdf color="#a10505" style={{ width:'20px', height:'30px'}}/>
                                </p>
                              </a></p>
                              </span>
                              )}
                              </React.Fragment>
                    )}
                     {formData?.whetherAirportPermissionRequired === 'no' && (
                      
                      <React.Fragment>
                      {formData?.whetherAirportPermissionRequired}
                              </React.Fragment>
                    )}
                  </td>
                  <td>
                    {formData?.whetherAirportPermissionRequired_remarks}
                  </td>
                  <td>
                    {formData?.whetherAirportPermissionRequired_relaxation}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
          </div>
    </React.Fragment>
  );
};

export default BPACheckListPreview;
